import types from '@store/constants/fxServiceManagerConstants';

const initialState = {
  fxRatesConfig: {
    isLoading: false,
    isError: false,
    error: null,
    data: null
  },
  vanceFxRates: {
    isLoading: false,
    isError: false,
    error: null,
    data: null
  }
};

const fxServiceManagerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_FX_RATES_CONFIG:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case types.GET_FX_RATES_CONFIG_SUCCESS:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case types.GET_FX_RATES_CONFIG_FAILURE:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: false,
          isError: true,
          error: payload
        }
      };
    case types.UPDATING_FX_RATES_CONFIG:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: true
        }
      };
    case types.UPDATE_FX_RATES_CONFIG_SUCCESS:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: false,
          data: payload
        }
      };
    case types.UPDATE_FX_RATES_CONFIG_FAILURE:
      return {
        ...state,
        fxRatesConfig: {
          ...state.fxRatesConfig,
          isLoading: false,
          isError: true,
          error: payload
        }
      };
    case types.RESET_FX_RATES_CONFIG_DATA:
      return {
        ...state,
        fxRatesConfig: {
          isLoading: false,
          isError: false,
          error: null,
          data: null
        }
      };

    // Vance FX Rates
    case types.GETTING_VANCE_FX_RATES:
      return {
        ...state,
        vanceFxRates: {
          ...state.vanceFxRates,
          isLoading: true,
          isError: false,
          error: null
        }
      };
    case types.GET_VANCE_FX_RATES_SUCCESS:
      return {
        ...state,
        vanceFxRates: {
          ...state.vanceFxRates,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };
    case types.GET_VANCE_FX_RATES_FAILURE:
      return {
        ...state,
        vanceFxRates: {
          ...state.vanceFxRates,
          isLoading: false,
          isError: true,
          error: payload
        }
      };

    default:
      return state;
  }
};

export default fxServiceManagerReducer;
